import { Modal, styled } from '@mui/material';

export const MuiModalStyled = styled(Modal)<{ ownerState: { fullScreen?: boolean } }>(
  ({ ownerState: { fullScreen } }) => ({
    '& > .MuiBox-root': {
      ...(fullScreen && {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        transform: 'unset',
        borderRadius: 'unset',
      }),
    },
  }),
);
